import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';

@Pipe({ name: 'linkify', standalone: true })
@Injectable({providedIn: 'root'})
export class LinkifyPipe implements PipeTransform {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	urlRegex: any = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
	
	transform(value) {
		return this.angularHelperService.trustAsHtml(value.replace(this.urlRegex, function(url) {
			return '<a href="' + url + '" target="_blank" rel="noopener" class="c-text c-text--underline">' + url + '</a>';
		}));
	}
	
}